import { render, staticRenderFns } from "./FormRecSetUpHowen.vue?vue&type=template&id=67a0f159&scoped=true&"
import script from "./FormRecSetUpHowen.vue?vue&type=script&lang=ts&"
export * from "./FormRecSetUpHowen.vue?vue&type=script&lang=ts&"
import style0 from "./FormRecSetUpHowen.vue?vue&type=style&index=0&id=67a0f159&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a0f159",
  null
  
)

export default component.exports